/* eslint-disable camelcase */
import React from 'react'
import { connect } from 'react-redux'
import { push } from '@lagunovsky/redux-react-router'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { arrayOf } from '../../../../utils/StoreUtils'
import DtoSTEPTerritoryEmissions from '../dto/DtoSTEPTerritoryEmissions'
import InstallationAction from '../../../actions/InstallationAction'
import DtoInstallation from '../../../dto/installation/DtoInstallation'
import ProgressCard from '../../../../components/card/ProgressCard'
import { nbPerPageLabelMedium } from '../../../../referencial/constants/ReferencialConstants'
import SieauAction from '../../../../components/sieau/SieauAction'
import { getStationTitleWithTownName } from '../../../../utils/StationUtils'
import ActionComponent from '../../../../components/ActionComponent'
import { multiLinesi18n } from '../../../../utils/StringUtil'
import { componentHasHabilitations } from '../../../../utils/HabilitationUtil'
import { H_STATION_INSTALLATION_STEP } from '../../../../account/constants/AccessRulesConstants'
import { exportFile } from 'utils/ExportDataUtil'
import MultiAutocomplete from 'components/forms/MultiAutocomplete'
import { Button, Card, CardContent, Grid, Stack } from '@mui/material'
import { isEmpty, keys, sortBy } from 'lodash'
import DtoSTEP from '../dto/DtoSTEP'
import { CardTable } from 'components/datatable/NewTable'

const headers = ['dataOrigin', 'activityCode', 'nbEstablishments', 'parameterCode', 'name', 'kgFlowEntrepriseDay',
    'kgFlowEmployeeDay', 'nbEmployees', 'totalFlowEmployees', 'totalFlowEntreprises', 'totalEmissionsEstablishments']
const headersSubscribers = ['parameterCode', 'label', 'emission']
const headersSubscribersExport = ['parameterCode', 'label', 'totalFlowTheo']

class STEPTerritoryApp extends ActionComponent {
    constructor(props) {
        super(props)
        this.state = {
            artisansLoaded: false,
            industriesLoaded: false,
            subscribersLoaded: false,
            activityFilter: [],
            basinFilter: [],
        }
    }

    componentDidMount = () => {
        if (!componentHasHabilitations(H_STATION_INSTALLATION_STEP)) { // A modifier quand react-router sera à jour
            this.props.push('/unauthorized')
            return
        }
        const { installation } = this.props
        this.props.fetchSTEPTerritoryArtisans({ code: installation.code }).then(() => {
            this.setState({ artisansLoaded: true })
        })

        this.props.fetchSTEPTerritoryIndustries({ code: installation.code }).then(() => {
            this.setState({ industriesLoaded: true })
        })

        this.props.fetchSTEPTerritorySubscribers(installation.code).then(() => {
            this.setState({ subscribersLoaded: true })
        })

        if (!this.props.activities.length) {
            this.props.fetchActivities()
        }

        if (isEmpty(this.props.installationSTEP)) {
            this.props.fetchInstallationSTEP(installation.id)
        }

        this.setTitle()
        this.setActions({})
    }

    componentDidUpdate(prevProps) {
        const { installation } = this.props
        if (installation.name && !prevProps.installation.name || (keys(prevProps.citiesIndex).length !== keys(this.props.citiesIndex).length)) {
            this.setTitle()
        }
    }

    setTitle = () => {
        const { installation } = this.props
        const townName = this.props.citiesIndex[installation.townCode]?.name

        this.props.forceFetch('title', [{
            title: i18n.installation,
            href: 'installation',
        }, {
            title: getStationTitleWithTownName(installation, townName),
            href: `station/installation/${installation.id}`,
        }, {
            title: i18n.emissions,
            href: `station/installation/${installation.id}/STEPTerritory`,
        }])
    }

    getTerritoryArtisansExport = () => {
        const { STEPTerritoryArtisans } = this.props
        exportFile({
            data: STEPTerritoryArtisans.map((d, i) => {
                return i === 0 ? { ...d, headers } : d
            }),
            titleFile: i18n.theoreticalEmissionsArtisans,
        })
    }

    getTerritoryIndustriesExport = () => {
        const { STEPTerritoryIndustries } = this.props
        exportFile({
            data: STEPTerritoryIndustries.map((d, i) => {
                return i === 0 ? { ...d, headers } : d
            }),
            titleFile: i18n.theoreticalIndustrialEmissions,
        })
    }

    getTerritorySubscribersExport = () => {
        const { STEPTerritorySubscribers } = this.props
        exportFile({
            data: STEPTerritorySubscribers.map((d, i) => {
                return i === 0 ? { ...d, headers: headersSubscribers, customHeaders: headersSubscribersExport } : d
            }),
            titleFile: i18n.theoreticalEmissionsDomesticCustomers,
        })
    }

    getTableActions = (getExportData = () => {}) => {
        return [
            {
                icon: 'file_download',
                tooltip: i18n.export,
                color: 'black',
                onClick: () => getExportData(),
            },
        ]
    }

    filter = () => {
        const { activityFilter, basinFilter } = this.state
        const { installation } = this.props

        const data = {
            code: installation.code,
            activities: activityFilter.length ? activityFilter : null,
            basins: basinFilter.length ? basinFilter : null,
        }
        this.props.fetchSTEPTerritoryArtisans(data)
        this.props.fetchSTEPTerritoryIndustries(data)
    }

    render() {
        const { artisansLoaded, industriesLoaded, subscribersLoaded, activityFilter, basinFilter } = this.state
        const { STEPTerritoryArtisans, STEPTerritoryIndustries, STEPTerritorySubscribers, activities, installationSTEP } = this.props

        const customHeaders = {
            dataOrigin: i18n.origin,
            parameterCode: multiLinesi18n(i18n.parameterCode),
            kgFlowEntrepriseDay: multiLinesi18n(i18n.kgFlowEntrepriseDay),
            kgFlowEmployeeDay: multiLinesi18n(i18n.kgFlowEmployeeDay),
            totalFlowEmployees: multiLinesi18n(i18n.totalFlowEmployees),
            totalFlowEntreprises: multiLinesi18n(i18n.totalFlowEntreprises),
            totalEmissionsEstablishments: multiLinesi18n(i18n.totalEmissionsEstablishments),
            nbEstablishments: i18n.numberInstitutions,
            nbEmployees: i18n.effective,
        }

        return (
            <Stack spacing={1} padding={1}>
                <Card>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid size={6}>
                                <MultiAutocomplete
                                    displayWithCode
                                    label={i18n.activities}
                                    elements={sortBy(activities, 'code')}
                                    clearFunction
                                    values={activityFilter}
                                    onChange={(values) => this.setState({ activityFilter: values })}
                                />
                            </Grid>
                            <Grid size={6}>
                                <MultiAutocomplete
                                    label={i18n.collectionBasins}
                                    elements={installationSTEP?.link_basins?.map(d => d.basinName ? d : { ...d, basinName: `[${d.basinCode}]` })}
                                    clearFunction
                                    keyName={'basinName'}
                                    keyId={'idBasin'}
                                    values={basinFilter}
                                    onChange={(values) => this.setState({ basinFilter: values })}
                                />
                            </Grid>
                            <Grid container size={12} justifyContent='flex-end'>
                                <Button onClick={this.filter} className='right' variant='contained' color='primary'>
                                    {i18n.search}
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                {artisansLoaded &&
                        (
                            <CardTable
                                title={i18n.theoreticalEmissionsArtisans}
                                rows={STEPTerritoryArtisans}
                                actions={this.getTableActions(this.getTerritoryArtisansExport)}
                                headers={headers}
                                headersLabel={customHeaders}
                                rowsPerPageOptions={nbPerPageLabelMedium}
                            />
                        ) || <ProgressCard indeterminate={true} />
                }
                {industriesLoaded &&
                        (
                            <CardTable
                                title={i18n.theoreticalIndustrialEmissions}
                                rows={STEPTerritoryIndustries}
                                actions={this.getTableActions(this.getTerritoryIndustriesExport)}
                                headers={headers}
                                headersLabel={customHeaders}
                                rowsPerPageOptions={nbPerPageLabelMedium}
                            />
                        ) || <ProgressCard indeterminate={true} />
                }
                {subscribersLoaded &&
                        (
                            <CardTable
                                title={i18n.theoreticalEmissionsDomesticCustomers}
                                rows={STEPTerritorySubscribers}
                                actions={this.getTableActions(this.getTerritorySubscribersExport)}
                                headers={headersSubscribers}
                                headersLabel={{
                                    emission: i18n.totalFlowTheo,
                                }}
                                rowsPerPageOptions={nbPerPageLabelMedium}
                            />
                        ) || <ProgressCard indeterminate={true} />
                }
            </Stack>
        )
    }
}

STEPTerritoryApp.propTypes = {
    STEPTerritoryArtisans: arrayOf(DtoSTEPTerritoryEmissions),
    STEPTerritoryIndustries: arrayOf(DtoSTEPTerritoryEmissions),
    STEPTerritorySubscribers: PropTypes.arrayOf(PropTypes.shape({
        parameterCode: PropTypes.string,
        shortLabel: PropTypes.string,
        Emission: PropTypes.number,
    })),
    forceFetch: PropTypes.func,
    push: PropTypes.func,
    fetchSTEPTerritoryArtisans: PropTypes.func,
    fetchSTEPTerritoryIndustries: PropTypes.func,
    fetchSTEPTerritorySubscribers: PropTypes.func,
    installation: PropTypes.instanceOf(DtoInstallation),
    installationSTEP: PropTypes.instanceOf(DtoSTEP),
    citiesIndex: PropTypes.objectOf(PropTypes.shape({
        name: PropTypes.string,
    })),
}

const mapStateToProps = store => ({
    installation: store.InstallationReducer.installation,
    STEPTerritoryArtisans: store.InstallationReducer.STEPTerritoryArtisans,
    STEPTerritoryIndustries: store.InstallationReducer.STEPTerritoryIndustries,
    STEPTerritorySubscribers: store.InstallationReducer.STEPTerritorySubscribers,
    activities: store.InstallationReducer.activities,
    installationSTEP: store.InstallationReducer.installationSTEP,
    citiesIndex: store.CityReducer.citiesIndex,
})

const mapDispatchToProps = {
    fetchSTEPTerritoryArtisans: InstallationAction.fetchSTEPTerritoryArtisans,
    fetchSTEPTerritoryIndustries: InstallationAction.fetchSTEPTerritoryIndustries,
    fetchSTEPTerritorySubscribers: InstallationAction.fetchSTEPTerritorySubscribers,
    forceFetch: SieauAction.forceFetch,
    push,
    fetchActivities: InstallationAction.fetchActivities,
    fetchInstallationSTEP: InstallationAction.fetchInstallationSTEP,
}


export default connect(mapStateToProps, mapDispatchToProps)(STEPTerritoryApp)
